<div class="row g-0">
  <div class="col-auto d-flex flex-row align-items-center box__one">
    <img [src]="icon" width="30px" height="30px" (click)="onClick()" />
    <div class="text__one" (click)="onClick()" [class]="lang.isRTL ? 'rtl-text__one' : ''">{{ label }}</div>
  </div>
</div>
